import { render, staticRenderFns } from "./task_view.vue?vue&type=template&id=2196da88&scoped=true"
import script from "./task_view.vue?vue&type=script&lang=js"
export * from "./task_view.vue?vue&type=script&lang=js"
import style0 from "./task_view.vue?vue&type=style&index=0&id=2196da88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2196da88",
  null
  
)

export default component.exports